module.exports = __webpack_public_path__ + "static/media/elk_clipboard_bg_sm.6bd5b44b.jpg";